import {
  ChevronDownOutlineIcon,
  ChevronUpOutlineIcon,
  Icon,
  SelectorOutlineIcon,
} from '@fountain/ripple/icon';
import React from 'react';

interface ApprovalSortIconProps {
  active?: boolean;
  direction: string;
  className?: string;
}

export const ApprovalSortIcon = ({
  active = false,
  direction,
  className,
}: ApprovalSortIconProps) => (
  <Icon
    icon={
      !active
        ? SelectorOutlineIcon
        : direction === 'asc'
          ? ChevronDownOutlineIcon
          : ChevronUpOutlineIcon
    }
    size="sm"
    color="inherit"
    className={className}
    // Keep the inactive cue visible and prevent MUI from rotating directional glyphs.
    style={{ transform: 'none', opacity: 1 }}
  />
);
